import {useState} from "../../__snowpack__/pkg/react.js";
import {axios} from "../lib/axios.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {handleError} from "../lib/errorHandler.js";
import {omit} from "../../__snowpack__/pkg/lodash.js";
export const useProductLocals = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    try {
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = await axios.post(`/saas/master-product/list`, {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...omit(search, "categories")
      });
      setData(content);
      return {
        productLocals: content,
        productLocalsPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        productLocals: data,
        productLocalsPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  const fetchBatchData = async (productIds, isIncomplete) => {
    setLoading(true);
    try {
      const {data: content} = await axios.post(isIncomplete ? `/saas/master-product/batch-get-incomplete` : `/saas/master-product/batch-get`, {
        productIds
      });
      setData(content);
      return {
        productLocals: content
      };
    } catch (error) {
      handleError(error);
      return {
        productLocals: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productLocalsLoading: loading,
    productLocals: data,
    fetchProductLocals: fetchData,
    fetchBatchProductLocals: fetchBatchData
  };
};
export const useProductLocalsModel = createModel(useProductLocals);
export const useMasterProductList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({
    pageTotal: 0,
    pageSize: 1,
    page: 1
  });
  const fetchData = async (searchInfo) => {
    setLoading(true);
    try {
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = await axios.post(`/saas/master-product/list`, {
        page: searchInfo && searchInfo.page && searchInfo.page - 1,
        size: searchInfo && searchInfo.pageSize,
        ...omit(searchInfo, ["page", "pageSize"])
      });
      setData(content);
      setPageInfo({
        page: page + 1,
        pageSize,
        pageTotal
      });
      return {
        productLocals: content,
        productLocalsPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        productLocals: data,
        productLocalsPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    ProductListLoading: loading,
    ProductList: data,
    ProductPageInfo: pageInfo,
    fetchProductList: fetchData
  };
};
export const uuseMasterProductListModel = createModel(useMasterProductList);
export const useProductLocalChildList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (id) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get(`/saas/master-product/${id}/child-list`, {});
      setData(data2);
      return {
        productLocalChildList: data2
      };
    } catch (error) {
      handleError(error);
      return {
        productLocalChildList: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productLocalChildListLoading: loading,
    productLocalChildList: data,
    fetchProductLocalChildList: fetchData
  };
};
export const useProductLocalChildListModel = createModel(useProductLocalChildList);
export const useProductLocalCount = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (search) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/master-product/count-by-status`, {
        ...omit(search, ["categories", "status"])
      });
      setData(data2);
      return {
        productLocalCount: data2
      };
    } catch (error) {
      handleError(error);
      return {
        productLocalCount: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productLocalCountLoading: loading,
    productLocalCount: data,
    fetchProductLocalCount: fetchData
  };
};
export const useProductLocalTabCount = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (search) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/master-product/count-by-tab`, {
        ...omit(search, ["categories", "status"])
      });
      setData(data2);
      return {
        productLocalCount: data2
      };
    } catch (error) {
      handleError(error);
      return {
        productLocalCount: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productLocalCountLoading: loading,
    productLocalCount: data,
    fetchProductLocalCount: fetchData
  };
};
export const useProductLocalTagCount = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (search) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/master-product/count-by-tab`, {
        ...omit(search, ["categories", "status"])
      });
      setData(data2);
      return {
        productLocalCount: data2
      };
    } catch (error) {
      handleError(error);
      return {
        productLocalCount: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productLocalTagCountLoading: loading,
    productLocalTagCount: data,
    fetchProductTagLocalCount: fetchData
  };
};
export const useProductLocalCountModel = createModel(useProductLocalCount);
export const useProductLocal = () => {
  const [data, setData] = useState(void 0);
  const [loading, setLoading] = useState(false);
  const fetchData = async (productId) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get(`/saas/master-product/get`, {
        params: {productId}
      });
      setData(data2);
      return {
        productLocal: data2
      };
    } catch (error) {
      handleError(error);
      return {
        productLocal: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productLocalLoading: loading,
    productLocal: data,
    fetchProductLocal: fetchData
  };
};
export const useProductLocalModel = createModel(useProductLocal);
export const useMasterVariations = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    try {
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = await axios.post(`/saas/master-variation/list`, {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...omit(search, "categories")
      });
      setData(content);
      return {
        masterVariations: content,
        masterVariationsPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        masterVariations: data,
        masterVariationsPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    masterVariationsLoading: loading,
    masterVariations: data,
    fetchMasterVariations: fetchData
  };
};
export const useMasterVariationsModel = createModel(useMasterVariations);
export const useBriefMasterVariations = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search, isOld) => {
    setLoading(true);
    try {
      const res = await axios.post(isOld ? `/saas/inventories/brief-list` : `/saas/master-variation/choose-bundle/list`, {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...omit(search, "categories")
      });
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = isOld ? {
        ...res,
        data: {
          content: res.data,
          number: 0,
          size: 0,
          totalElements: 0
        }
      } : res;
      setData(content);
      return {
        briefMasterVariations: content,
        briefMasterVariationsPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        briefMasterVariations: data,
        briefMasterVariationsPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    briefMasterVariationsLoading: loading,
    setBriefMasterVariationsLoading: setLoading,
    briefMasterVariations: data,
    fetchBriefMasterVariations: fetchData
  };
};
export const useBriefMasterVariationsModel = createModel(useBriefMasterVariations);
export const useChannelVariations = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    try {
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = await axios.post(`/saas/master-variation/search-channel-variation`, {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...omit(search)
      });
      setData(content);
      return {
        channelVariations: content,
        channelVariationsPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        channelVariations: data,
        channelVariationsPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    channelVariationsLoading: loading,
    channelVariations: data,
    fetchChannelVariations: fetchData
  };
};
export const useChannelVariationsModel = createModel(useChannelVariations);
export const useChannelVariationsCount = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async (search) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/master-variation/count-channel-variation`, {
        ...omit(search)
      });
      setData(data2);
      return {
        channelVariationsCount: data2
      };
    } catch (error) {
      handleError(error);
      return {
        channelVariationsCount: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    channelVariationsCountLoading: loading,
    channelVariationsCount: data,
    fetchChannelVariationsCount: fetchData
  };
};
export const useChannelVariationsCountModel = createModel(useChannelVariationsCount);
export const useRelatedShops = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (id) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get(`/saas/master-variation/list-related-shop?variationId=${id}`);
      setData(data2);
      return {
        relatedShops: data2
      };
    } catch (error) {
      handleError(error);
      return {
        relatedShops: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    relatedShopsLoading: loading,
    relatedShops: data,
    fetchRelatedShops: fetchData
  };
};
export const useRelatedShopsModel = createModel(useRelatedShops);
